import { Component, Input } from '@angular/core';

import { DeelDetailsItemComponent } from '../deel-details-item/deel-details-item.component';

@Component({
  selector: 'parkour-deel-details-list',
  templateUrl: './deel-details-list.component.html',
  standalone: true,
  imports: [DeelDetailsItemComponent],
})
export class DeelDetailsListComponent {
  @Input() blocked = false;
}
